import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "MoveMruActions"*/ './lazyIndex'),
    { name: 'MoveMruActions' }
);

export const lazyAddFolderIdToMoveToMruList: LazyAction<
    typeof lazyIndex.addFolderIdToMoveToMruListMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.addFolderIdToMoveToMruListMutator);

export const lazyRemoveFolderIdFromMoveToMruList: LazyAction<
    typeof lazyIndex.removeFolderIdFromMoveToMruListMutator,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.removeFolderIdFromMoveToMruListMutator);

export const lazyGetMoveToMruList: LazyAction<
    typeof lazyIndex.getMoveToMruList,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getMoveToMruList);
